const i = "_file_o2d86_1", e = "_finishedUploadingFile_o2d86_9", o = {
  file: i,
  finishedUploadingFile: e,
  "file-item": "_file-item_o2d86_13",
  "clear-button": "_clear-button_o2d86_27",
  "file-actions": "_file-actions_o2d86_32",
  "file-footer": "_file-footer_o2d86_39"
};
export {
  o as default,
  i as file,
  e as finishedUploadingFile
};
//# sourceMappingURL=index.es5604.js.map
